module.exports = __webpack_public_path__ + "static/media/controlSales.34c8aee3.png";